import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Typography,
  Form,
  Input,
  Button,
  Spin,
  notification,
  Row,
  Col,
} from "antd";
import PasswordStrengthBar from "react-password-strength-bar";
import UserApi from "../common/Apis/UserApi";
import RegisterForm from "../common/CommonUI/RegisterForm/RegisterForm";

const { Title } = Typography;
const ChangePassword = (props) => {
  let navigate = useNavigate();

  const urlParams = new URLSearchParams(window.location.search);
  let token = urlParams.get("token");
  let UserEmail = urlParams.get("email");
  const [inputPassword, setInputPassword] = React.useState("");
  const [inputValuestart, setinputValuestart] = React.useState(true);
  const [loadings, setLoadings] = useState(false);

  // Visible user input password and confirm password

  const [passwordVisible, setPasswordVisible] = React.useState(false);

  // validating user password strength set value

  const handleChangePassword = (event) => {
    setInputPassword(event.target.value);
    setinputValuestart(false);
  };

  const handleSubmit = (data) => {
    setLoadings(true);
    const formData = new FormData();
    formData.append("userName", UserEmail);
    formData.append("password", inputPassword);
    if (inputPassword == data.Cpassword) {
      UserApi.resetPasswordToken(token, formData)
        .then((response) => {
          setLoadings(false);
          notification.open({
            message: (
              <span style={{ fontWeight: "bold" }}>
                {response.resultStatus}
              </span>
            ),
            description: response.payload,
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#b3ffb3",
              color: "green",
            },
          });
          setTimeout(() => {
            return navigate("/");
          }, 3000);
        })
        .catch((err) => {
          setLoadings(false);
          notification.open({
            message: <span style={{ fontWeight: "bold" }}>Error</span>,
            description: err.apiError.message,
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#ffb3b3",
              color: "red",
            },
          });
          setTimeout(() => {
            return navigate("/");
          }, 3000);
        });
    } else {
      setLoadings(false);
      notification.open({
        message: <span style={{ fontWeight: "bold" }}>Error</span>,
        description: "Password Not Match!",
        closeIcon: false,
        duration: 3,
        style: {
          backgroundColor: "#ffb3b3",
          color: "red",
        },
      });
    }
  };

  useEffect(() => {
    if (!token) {
      // return navigate("/");
    }
  }, [token]);

  return (
    <>
      <div className="container container-body form-container">
        <div className="row justify-content-center">
          <div className="col-xl-9 col-lg-9 col-md-9 content-border my-5">
            <Row gutter={24}>
              <RegisterForm />
              <Col
                lg={12}
                md={24}
                className="py-4"
                style={{ boxShadow: "8px 8px 16px -4px rgba(0, 0, 0, 0.1)" }}
              >
                <Form
                  name="nest-messages"
                  layout="vertical"
                  onFinish={handleSubmit}
                  className="py-3 px-4 Register-form"
                >
                  <div className="d-flex justify-content-center pb-4">
                    <img
                      src="/assest/Images/Logo/logo.png"
                      className="logo-png"
                    />
                  </div>

                  <Title
                    style={{
                      textAlign: "center",
                      color: "black",
                      marginBottom: 30,
                    }}
                    level={4}
                    className="Primary-Font"
                  >
                    Change Password
                  </Title>

                  <>
                    <Form.Item name="NewPassword" className="text-lable">
                      <Input.Password
                        placeholder="Choose a New Password"
                        className="control-input mb-2"
                        onChange={handleChangePassword}
                        type="password"
                        visibilityToggle={{
                          visible: passwordVisible,
                          onVisibleChange: setPasswordVisible,
                        }}
                      />

                      {inputPassword !== "" ? (
                        <>
                          <PasswordStrengthBar
                            className="password-progress"
                            password={inputPassword}
                            minLength={5}
                          />
                        </>
                      ) : (
                        <>
                          {inputValuestart === true ? (
                            <>
                              <p className="content-info ">
                                8 characters or longer. Combine upper and
                                lowercase letters and numbers.
                              </p>
                            </>
                          ) : (
                            <>
                              <p
                                className="content-info "
                                style={{ color: "red" }}
                              >
                                Password must be min. 8 characters. Combine
                                numbers, special characters, upper and lowercase
                                letters.
                              </p>
                            </>
                          )}
                        </>
                      )}
                    </Form.Item>
                    <Form.Item name="Cpassword" className="text-lable">
                      <Input.Password
                        placeholder="Confirm Password"
                        className="control-input"
                      />
                    </Form.Item>
                    <Button
                      type="primary"
                      htmlType="submit"
                      className="btn btn-primary mt-0 w-100"
                      disabled={loadings == true}
                    >
                      Continue {loadings == true && <Spin className="px-2" />}
                    </Button>
                    <p className="content signup-content py-4 my-5">
                      Already a member?{" "}
                      <Link to={"/"} className="content-link">
                        Sign In
                      </Link>
                    </p>
                  </>
                </Form>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChangePassword;
